import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController, Events } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { AppState } from '../../config/state';
import { IpcService } from '../../providers/ipc/ipc';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { CoLogoutSurveyPage } from '../co-logout-survey/co-logout-survey';
import { LoginProvider } from '../../providers/login/login';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { MailProvider } from '../../providers/mail/mail';
import moment from 'moment';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
/**
 * Generated class for the CoCheckoutConfirmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-checkout-confirm',
  templateUrl: 'co-checkout-confirm.html',
})
export class CoCheckoutConfirmPage {
  currentScreen: string;
  bookList: any = [];
  patron: any = {};
  idents: any = [];
  chosenIsbn: string;
  chosenUpc: string;
  ifRecommended: boolean = false;
  viewType: any;
  staffScreen: boolean;
  surveyScreen: boolean = false;
  patronInfo: {email: string, phone: string, emailValid: boolean, phoneValid: boolean} = {email: "", phone: "", emailValid: true, phoneValid: true};
  emailRegex: any;
  phoneRegex: any;
  pastTense: string;
  constructor(public navCtrl: NavController, public navParams: NavParams, public config: ConfigProvider, public state: AppState, private ipc:IpcService, private novelist:NovelistProvider, private modalCtrl : ModalController, private viewCtrl : ViewController, private loginProvider : LoginProvider, private toast : ToastAlertsProvider, private mailProvider : MailProvider, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.viewType = this.state.mode;
    this.currentScreen = this.navParams.data.page;
    this.bookList = this.navParams.data.books;
    this.staffScreen = this.state.staff;
    // console.log('booklist', this.bookList, this.state);
    this.patron = this.navParams.data.patron;
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
  }
  novelistLoaded(state){
    this.ifRecommended=true;
  }
  ngOnInit() {
    // this.idents = this.bookList.reduce((ret, book)=>{
    //   const bib = this.currentScreen === 'renew' ? book.bib : book;
    //   ret.push(...bib.isbns.map(i=>{return {type: 'isbn', id:i}}))
    //   ret.push(...bib.upcs.map(i=>{return {type: 'upc', id:i}}))
    //   return ret;
    // }, []);
    switch(this.currentScreen){
      case('checkin'):
        this.pastTense = 'returned';
        break;
      case('checkout'):
        this.pastTense = 'checked out';
        break;
      case('renew'):
        this.pastTense = 'renewed';
        break;
    }
  }

  async printInfo(screen){
    let details;
    if(this.idents && this.idents.length>0){
        for (let ident of  this.idents) {
        if(details)break;
        if(ident.type=='isbn'){
          details = await this.novelist.getItemDetailsFromISBN(ident.id);
        }else if(ident.type=='upc'){
          details = await this.novelist.getItemDetailsFromUPC(ident.id);
        }else if (ident.type=='barcode'){
          details = await this.novelist.getItemDetailsFromBarcode(ident.id);
        }
      };
    }
    this.ipc.send('printItemCheckoutReceipt', {
      patron: this.patron,
      books: this.bookList,
      similarTitles: details && details.similarTitles ? details.similarTitles : false
    });
    //printing Function
    // console.log('printing', this.bookList, 'current screen', screen);
  }
  logOut(){
    this.state.patron = false;
    this.loginProvider.logout();
    if (this.staffScreen){
      this.navCtrl.popToRoot();
    } else {
      let modal = this.modalCtrl.create(CoLogoutSurveyPage);
      this.navCtrl.popToRoot();
      modal.present();
    }
  }

  close(receipt: boolean){
    if (this.state.sharedScreen && !this.state.staff){
      this.viewCtrl.dismiss(receipt).catch(err=>{});
    } else {
      this.viewCtrl.dismiss(receipt).catch(err=>{});
    }
  }

  sendReceipt(isEmail){
    let barcodeDetails = `Customer ID: **********${this.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`
    let emailList = "";
    this.bookList.forEach(book => {
      if (book.bookPassed){
        emailList += `Title: ${book.title} \n Id: ${book.id} \n Due: ${moment(book.returnDate).format('MM/DD/YYYY')} \n \n`
      }
    });
    let emailVars ={
      first_name: this.patron.firstName,
      screen_type: this.currentScreen,
      branch_name: 'My Peop',
      barcode_end: barcodeDetails,
      book_list: encodeURIComponent(emailList),
      past_tense: this.pastTense,
      total: this.bookList.length
    }
    if (isEmail){
      if (this.patronInfo.email.length > 0){
        if (this.emailRegex.test(this.patronInfo.email)){
          this.patronInfo.emailValid = true;
          this.mailProvider.sendBookReceipt(this.patronInfo.email, emailVars, isEmail).then(res=>{
            if (res.status){
              this.toast.triggerToast('Your receipt has been sent!','', 'success');
              this.close(true);
            } else {
              this.toast.triggerToast('Send failed, please retry','');
            }
          })
        } else {
          this.toast.triggerToast('Please enter a valid email address!','');
          this.patronInfo.emailValid = false;
        }
      } else {
        this.toast.triggerToast('Please enter a valid email address!','');
        this.patronInfo.emailValid = false;
      }
    } else {
      if (this.patronInfo.phone.length > 0 && this.patronInfo.phone.length < 11){
        if (this.phoneRegex.test(this.patronInfo.phone)){
          this.patronInfo.phone = this.patronInfo.phone.replace(/\D/g,'');
          this.patronInfo.phoneValid = true;
          //TODO: Added a 1 for US number code, will have to pull in from client settings in future
          this.mailProvider.sendBookReceipt(`1${this.patronInfo.phone}`, {first_name: this.patron.firstName || "meep", screen_type: this.currentScreen, branch_name: "Maple"}, isEmail).then(res=>{
            if (res.status){
              this.toast.triggerToast('Your receipt has been sent!','', 'success');
              this.close(true);
            } else {
              this.toast.triggerToast('Send failed, please retry','');
            }
          })
        } else {
          this.toast.triggerToast('Please enter a valid phone number!','');
          this.patronInfo.phoneValid = false;
        }
      } else {
        this.toast.triggerToast('Please enter a valid phone number!','');
        this.patronInfo.phoneValid = false;
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/co-checkout-confirm/co-checkout-confirm.ts